/* @author: Augusto Monteiro */

Greenmile.Panel = Greenmile.Panel || {};

Greenmile.Panel.Card = function () {

    this.cardBuilder = new Greenmile.PanelBuilder.CardView();
    this.cardEl = null;
    this.cardId = null;
    this.updateTime = null;

    this.create = function (fields, model, colors, flip) {
        this.cardId = model.route.id;
        this.cardEl = this.cardBuilder.render(fields, model, colors, flip);
        return this.cardEl;
    };

    this.destroy = function () {
        this.cardBuilder.destroyCard();
    };
};
